import React from 'react';
import { Box, CircularProgress } from '@mui/material';
 
const Loader = ({ size = 40, minHeight = "100vh", fullscreen = false }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={fullscreen ? "100vh" : minHeight}
      position={fullscreen ? "fixed" : "relative"}
      top={fullscreen ? 0 : "auto"}
      left={fullscreen ? 0 : "auto"}
      width={fullscreen ? "100vw" : "100%"}
      height={fullscreen ? "100vh" : "auto"}
      zIndex={fullscreen ? 9999 : "auto"}
      bgcolor={"white"}
      //bgcolor={fullscreen ? "rgba(255, 255, 255, 0.7)" : "transparent"}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
 
export default Loader;
 